import { format, formatDuration } from '@sequencehq/utils/dates'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const usePhaseDuration = (props: { phaseId: string }) => {
  const cubeContext = useCubeContext()

  const resolvedPhase = cubeContext.queries.resolvedPhases[props.phaseId]

  if (resolvedPhase.dates.duration === 'OPEN_ENDED') {
    return {
      differenceFormatted: 'Open ended',
      startDateFormatted: '',
      endDateFormatted: '',
      endDateDescription: 'Phase continues on an ongoing basis'
    }
  }

  if (resolvedPhase.dates.duration === 'MILESTONE') {
    return {
      differenceFormatted: 'Milestone based',
      startDateFormatted: resolvedPhase.dates.absolute.start
        ? format(resolvedPhase.dates.absolute.start, 'd LLLL yyyy')
        : '',
      endDateFormatted: 'Milestone based',
      endDateDescription: ''
    }
  }

  const endDateFormatted = resolvedPhase.dates.absolute.end
    ? format(resolvedPhase.dates.absolute.end, 'd LLLL yyyy')
    : ''

  return {
    differenceFormatted: formatDuration(
      {
        ...resolvedPhase.dates.duration,
        /**
         * The custom duration returned is inclusive of the start date (e.g. 14 days
         * on top of 1 Jan is 1st -> 15th Jan), so we need to add 1 to the days count
         * to represent this inclusive duration correctly when considering proration.
         */
        days: (resolvedPhase.dates.duration?.days ?? 0) + 1
      },
      {
        format: ['years', 'months', 'days']
      }
    ),
    startDateFormatted: resolvedPhase.dates.absolute.start
      ? format(resolvedPhase.dates.absolute.start, 'd LLLL yyyy')
      : '',
    endDateFormatted,
    endDateDescription: endDateFormatted
      ? `Phase ends on ${endDateFormatted}`
      : ''
  }
}
